export default __webpack_public_path__ + "static/media/Stat2021.1694781d.png";